import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../shared/api/client';
import { useAuthStore } from '../shared/store/authStore';
import { enumLabel } from '../shared/i18n/enumLabel';
import { Card } from '../shared/ui/Card';
import { ParkingDataTable } from '../shared/ui/ParkingDataTable';
import { StatusBadge, statusToneFromEnum } from '../shared/ui/StatusBadge';

export function UsersPage() {
  const { t } = useTranslation();
  const canRead = useAuthStore((s) => s.hasPermission('users:read'));
  const users = useQuery({
    queryKey: ['users'],
    queryFn: () => api.listUsers(),
    enabled: canRead,
  });

  if (!canRead) {
    return <div className="alert alert-warning">{t('users.forbidden')}</div>;
  }

  const rows = users.data?.data ?? [];

  return (
    <>
{users.isError && (
        <div className="alert alert-danger">{(users.error as Error).message}</div>
      )}
      <Card>
        <ParkingDataTable
          storageKey="users"
          columns={[t('users.email'), t('users.name'), t('users.status'), t('users.roles')]}
          refreshKey={rows.map((u) => u.id).join('|')}
          order={[[0, 'asc']]}
          actionsColumn={false}
          galleryItems={rows.map((u) => ({
            id: u.id,
            icon: 'bi-person',
            title: u.email,
            subtitle: `${u.firstName} ${u.lastName}`,
            meta: u.roles.join(', '),
            badge: (
              <StatusBadge tone={statusToneFromEnum(u.status)}>
                {enumLabel(t, 'userStatus', u.status)}
              </StatusBadge>
            ),
          }))}
        >
          {rows.map((u) => (
            <tr key={u.id}>
              <td>
                <div className="d-flex align-items-center gap-2">
                  <span className="symbol symbol-primary">
                    <i className="bi bi-person" />
                  </span>
                  <span className="fw-semibold">{u.email}</span>
                </div>
              </td>
              <td>
                {u.firstName} {u.lastName}
              </td>
              <td>
                <StatusBadge tone={statusToneFromEnum(u.status)}>
                  {enumLabel(t, 'userStatus', u.status)}
                </StatusBadge>
              </td>
              <td>{u.roles.join(', ')}</td>
            </tr>
          ))}
        </ParkingDataTable>
      </Card>
    </>
  );
}
